var render = function render(_c,_vm){return _c('blockquote',{staticClass:"blockquote container container--wide"},[_c('div',{staticClass:"wrap"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }